export interface VideoMeta {
  width: number;
  height: number;
  duration: number;
}

// Розміри (з урахуванням повороту) і тривалість відео — без них Telegram вгадує пропорції,
// і відео з iPhone приходить розтягнутим. Читаємо метадані прямо в браузері, сервер не потрібен.
export function readVideoMeta(file: File, timeoutMs = 5000): Promise<VideoMeta | null> {
  return new Promise(resolve => {
    const url = URL.createObjectURL(file);
    const video = document.createElement('video');
    const done = (meta: VideoMeta | null) => {
      clearTimeout(timer);
      video.removeAttribute('src');
      video.load();
      URL.revokeObjectURL(url);
      resolve(meta);
    };
    const timer = setTimeout(() => done(null), timeoutMs);
    video.preload = 'metadata';
    video.muted = true;
    video.playsInline = true;
    video.onloadedmetadata = () => done(video.videoWidth && video.videoHeight
      ? { width: video.videoWidth, height: video.videoHeight, duration: Math.round(video.duration || 0) }
      : null);
    video.onerror = () => done(null);
    video.src = url;
  });
}
